export default __webpack_public_path__ + "static/media/background.491fcd97.jpg";